export const translations = {
  ko: {
    nav: {
      features: "기능 소개",
      pricing: "요금제",
      enterprise: "기업용",
      start: "시작하기",
    },
    hero: {
      badge: "AI 채용 어시스턴트 v1.0",
      title_line1: "채용, 더 스마트하게.",
      title_line2: "힘들게 하지 마세요.",
      desc: "AI 기반 이력서 분석으로 채용 프로세스를 혁신하세요.<br/>핵심 요약부터 맞춤형 면접 질문, 리스크 진단까지 10초면 충분합니다.",
      cta_primary: "무료 분석 시작하기",
      cta_secondary: "데모 영상 보기",
    },
    features: {
      title: "현대적인 HR을 위한 강력한 기능",
      subtitle: "지원자를 효과적으로 검증하는 데 필요한 모든 도구.",
      f1_title: "3줄 핵심 요약",
      f1_desc: "장황한 자기소개서를 다 읽을 필요 없습니다. 성과와 핵심 기술만 요약해 드립니다.",
      f2_title: "면접 질문 생성기",
      f2_desc: "지원자의 경력 공백이나 약점을 파고드는 날카로운 질문을 자동으로 생성합니다.",
      f3_title: "리스크 진단",
      f3_desc: "잦은 이직, 기술 스택 불일치 등 채용 전 확인해야 할 위험 요소를 미리 경고합니다.",
    },
    footer: {
      rights: "© 2026 에스알컴즈 (SRComs). All rights reserved.",
    }
  },
  en: {
    nav: {
      features: "Features",
      pricing: "Pricing",
      enterprise: "Enterprise",
      start: "Get Started",
    },
    hero: {
      badge: "AI Recruiting Assistant v1.0",
      title_line1: "Hire Smarter,",
      title_line2: "Not Harder.",
      desc: "Transform your hiring process with AI-powered resume analysis.<br/>Get instant summaries, tailored interview questions, and risk assessments.",
      cta_primary: "Start Free Analysis",
      cta_secondary: "Watch Demo",
    },
    features: {
      title: "Powerful Features for Modern HR",
      subtitle: "Everything you need to evaluate candidates effectively.",
      f1_title: "Smart Summary",
      f1_desc: "Extracts key skills and achievements instantly. No more reading through 5-page resumes.",
      f2_title: "Interview Generator",
      f2_desc: "Generates deep, role-specific questions based on the candidate's actual experience gaps.",
      f3_title: "Risk Assessment",
      f3_desc: "Identifies red flags like frequent job hopping or skill gaps before you even schedule a call.",
    },
    footer: {
      rights: "© 2026 SRComs. All rights reserved.",
    }
  }
};

export type Language = "ko" | "en";
